const initMenu = () => {
  const control = document.getElementsByClassName('hero__nav-section--nav')[0];
  const menu = document.getElementsByClassName('hero__menu')[0];
  let menuOpen = false;

  const closeMenu = () => {
    const toShow = document.querySelectorAll('[data-navelement]');
    const toHide = document.getElementsByClassName('hero__menu-item');
    control.classList.remove('active');

    for (let i = 0; i < toHide.length; i++) {
      const element = toHide[i];

      setTimeout(() => {
        element.classList.remove('in');
      }, i * 50);
    }

    setTimeout(() => {
      menu.classList.remove('show');
      toShow.forEach((el, i) => {
        el.classList.remove('hide');

        setTimeout(() => {
          el.classList.remove('out');
        }, i * 50);
      });
    }, 300);

    menuOpen = false;
  };

  const openMenu = () => {
    const toHide = document.querySelectorAll('[data-navelement]');
    const toShow = document.getElementsByClassName('hero__menu-item');
    control.classList.add('active');

    for (let i = 0; i < toHide.length; i++) {
      const element = toHide[i];

      setTimeout(() => {
        element.classList.add('out');
      }, i * 50);
    }

    setTimeout(() => {
      menu.classList.add('show');

      toHide.forEach((el, i) => {
        el.classList.add('hide');
      });

      for (let i = 0; i < toShow.length; i++) {
        const element = toShow[i];

        setTimeout(() => {
          element.classList.add('in');
        }, i * 50);
      }
    }, 200);

    menuOpen = true;
  };

  control.addEventListener('click', () => {
    if (menuOpen) {
      closeMenu();
    } else {
      openMenu();
    }
  })
};

document.addEventListener('DOMContentLoaded', () => {
  initMenu();
});
